<div class="h-full w-full min-h-0 flex flex-col overflow-y-auto scrollbar-transparent">

    @if (!reviewHistory) {
    <!-- ── Pending empty state ─────────────────────────────────────────── -->
    <div class="h-full w-full flex flex-col items-center justify-center px-8 py-10 text-center">
        <div
            class="flex items-center justify-center size-16 rounded-2xl bg-violet-50 dark:bg-violet-500/10 mb-5 ring-1 ring-inset ring-violet-500/20">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" aria-hidden="true" class="size-8 text-violet-500 dark:text-violet-400">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
            </svg>
        </div>
        <h3 class="text-base font-semibold text-primary">AI review in progress</h3>
        <p class="mt-2 text-sm text-secondary max-w-sm">
            We are checking this draft against your brief. Scores and flagged issues will show here when the review
            finishes.
        </p>
    </div>

    } @else {
    <div class="w-full flex flex-col items-start justify-start p-3 gap-y-3">

        <!-- ── Overall Score card ────────────────────────────────────────── -->
        <!-- <div class="w-full rounded-2xl border border-emerald-500/25 bg-white dark:bg-zinc-900/80 px-4 py-3 shadow-sm dark:shadow-none"> -->
        <div class="w-full briefing-section-card">
            <div class="flex items-center gap-x-3">
                <div class="shrink-0 flex items-center justify-center size-10 rounded-xl bg-emerald-50 dark:bg-emerald-500/10">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-emerald-500 dark:text-emerald-400">
                        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                        <path d="M20 2v4" /><path d="M22 4h-4" /><circle cx="4" cy="20" r="2" />
                    </svg>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-primary">AI Review Score</p>
                    <div class="flex flex-wrap items-center gap-2 mt-1.5">
                        <span class="inline-flex items-center gap-x-1 rounded-full bg-emerald-50 dark:bg-emerald-500/10 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:text-emerald-400 ring-1 ring-inset ring-emerald-500/20">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="size-3 text-emerald-500" aria-hidden="true">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                            Approved: {{ reviewHistory.approvedTotal }}
                        </span>
                        <span class="inline-flex items-center gap-x-1 rounded-full bg-red-50 dark:bg-red-500/10 px-2 py-0.5 text-xs font-medium text-red-700 dark:text-red-400 ring-1 ring-inset ring-red-500/20">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="size-3 text-red-500" aria-hidden="true">
                                <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                            </svg>
                            Issues: {{ reviewHistory.issuesTotal }}
                        </span>
                    </div>
                </div>
                <div class="shrink-0 text-xl font-bold text-primary tabular-nums">
                    {{ reviewHistory.score | number:'1.0-0' }}%
                </div>
            </div>
        </div>
        <!-- Overall Score - END -->


        <!-- ── Do's accordion ────────────────────────────────────────────── -->
        @if (doResults() && doResults().length > 0) {
        @if (resultsOnly) {
        <ng-container *ngTemplateOutlet="doAccordion"></ng-container>
        } @else {
        <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]" class="w-full">
            <ng-container *ngTemplateOutlet="doAccordion"></ng-container>
        </div>
        }
        }
        <!-- Do's - END -->


        <!-- ── Don't's accordion ─────────────────────────────────────────── -->
        @if (dontResults() && dontResults().length > 0) {
        @if (resultsOnly) {
        <ng-container *ngTemplateOutlet="dontAccordion"></ng-container>
        } @else {
        <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]" class="w-full">
            <ng-container *ngTemplateOutlet="dontAccordion"></ng-container>
        </div>
        }
        }
        <!-- Don't's - END -->


        <!-- ── No bolt-on: preview card ─────────────────────────────────── -->
        @if (!resultsOnly) {
        <div *notHasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
            class="w-full flex flex-col gap-y-3">

            @if (firstFailedResult()) {
            <ng-container *ngTemplateOutlet="resultCard; context: { result: firstFailedResult() }"></ng-container>
            }

            <!-- Upsell card -->
            <div class="w-full rounded-2xl border border-zinc-100 dark:border-white/5 bg-white dark:bg-zinc-900 overflow-hidden shadow-sm dark:shadow-none">
                <div class="flex items-center gap-x-3 px-4 py-3 border-b border-zinc-100 dark:border-white/5">
                    <div class="shrink-0 size-10 rounded-xl flex items-center justify-center bg-gradient-to-br from-brand-purple to-brand-studio shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-white">
                            <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                            <path d="m16 12-4-4-4 4" /><path d="M12 16V8" />
                            <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                            <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                            <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                            <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                        </svg>
                    </div>
                    <div class="min-w-0 flex-1">
                        <p class="text-sm font-semibold text-primary">Add AI Moderation Bolt-On</p>
                        <p class="text-xs text-secondary">
                            You're seeing a preview —
                            {{ reviewHistory.reviewResults.length - 1 }} more findings are hidden.
                        </p>
                    </div>
                </div>
                <div class="px-4 py-3 flex flex-col gap-y-3">
                    <ul class="flex flex-col gap-y-1.5">
                        @for (item of [
                            'Complete Do\'s & Don\'ts checklist',
                            'Detailed explanations for each issue',
                            'Suggested fixes with timestamps',
                            'Transcript & visual OCR matches'
                        ]; track $index) {
                        <li class="flex items-start gap-x-2 text-xs text-secondary">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-3.5 text-emerald-500 shrink-0 mt-0.5" aria-hidden="true">
                                <circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" />
                            </svg>
                            <span>{{ item }}</span>
                        </li>
                        }
                    </ul>
                    <button (click)="openChoosePlan()" type="button"
                        class="w-full inline-flex items-center justify-center gap-x-2 flashy-go-button rounded-xl hover:cursor-pointer">
                        Add Bolt-On
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4" aria-hidden="true">
                            <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                            <path d="m16 12-4-4-4 4" /><path d="M12 16V8" />
                            <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                            <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                            <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                            <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        }
        <!-- No bolt-on - END -->


        <!-- ── Send Feedback accordion ───────────────────────────────────── -->
        @if (!resultsOnly && reviewHistory && reviewHistory.issuesTotal && reviewHistory.issuesTotal > 0) {
        <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
            class="w-full rounded-2xl border border-zinc-100 dark:border-white/5 bg-white dark:bg-zinc-900 overflow-hidden shadow-sm dark:shadow-none">

            <!-- Header -->
            <button type="button" (click)="sendFeedbackCollapsed.set(!sendFeedbackCollapsed())"
                class="w-full flex items-center gap-x-3 px-4 py-3 text-left hover:bg-zinc-50 dark:hover:bg-white/3 transition-colors duration-150"
                [attr.aria-expanded]="!sendFeedbackCollapsed()">
                <div class="shrink-0 flex items-center justify-center size-8 rounded-lg bg-primary/10 dark:bg-primary/10">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"
                        class="size-4 text-accent" aria-hidden="true">
                        <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                        <path d="m21.854 2.147-10.94 10.939" />
                    </svg>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-primary">Send Feedback</p>
                    <p class="text-xs text-secondary">Would you like to send this feedback to the creator?</p>
                </div>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                    class="size-4 text-zinc-400 shrink-0 transition-transform duration-200"
                    [class.rotate-180]="!sendFeedbackCollapsed()" aria-hidden="true">
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </button>

            @if (!sendFeedbackCollapsed()) {
            <div class="border-t border-zinc-100 dark:border-white/5 p-3 flex flex-col gap-y-3">
                @if (defaultMessageText()) {
                <!-- Suggested message preview -->
                <div class="rounded-xl bg-primary/10 dark:bg-primary/10 border border-primary/20 dark:border-primary/25 p-3">
                    <p class="text-xs font-medium text-primary mb-1">Draft message</p>
                    <p class="text-xs text-primary whitespace-pre-wrap leading-relaxed">{{ defaultMessageText() }}</p>
                </div>
                <div class="flex justify-end">
                    <button (click)="sendSuggestedFeedback()" type="button"
                        class="inline-flex items-center gap-x-1.5 rounded-full bg-primary hover:bg-primary/90 active:bg-primary/95 dark:bg-primary dark:hover:bg-primary/90 px-4 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                        Send Feedback
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="size-3.5" aria-hidden="true">
                            <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                            <path d="M12 11h.01" /><path d="M16 11h.01" /><path d="M8 11h.01" />
                        </svg>
                    </button>
                </div>
                } @else {
                <!-- Loading state -->
                <div class="flex items-center gap-x-3 rounded-xl border border-zinc-100 dark:border-white/5 bg-zinc-50 dark:bg-zinc-800/40 px-4 py-3">
                    <svg class="animate-spin size-5 text-accent shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"/>
                        <path class="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                    <div>
                        <p class="text-xs font-medium text-primary">Loading…</p>
                        <p class="text-xs text-secondary">Fetching brief analysis.</p>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
        <!-- Send Feedback - END -->

    </div>
    }


    <ng-template #doAccordion>
        <div class="w-full rounded-2xl border border-zinc-100 dark:border-white/5 bg-white dark:bg-zinc-900 overflow-hidden shadow-sm dark:shadow-none">
            <button type="button" (click)="doCollapsed.set(!doCollapsed())"
                class="w-full flex items-center gap-x-3 px-4 py-3 text-left hover:bg-zinc-50 dark:hover:bg-white/3 transition-colors duration-150"
                [attr.aria-expanded]="!doCollapsed()">
                <div class="shrink-0 flex items-center justify-center size-8 rounded-lg bg-emerald-50 dark:bg-emerald-500/10">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="size-4 text-emerald-500 dark:text-emerald-400" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-primary">Requirements (Do's)</p>
                    <p class="text-xs text-secondary">Items that should be included in the content.</p>
                </div>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                    class="size-4 text-zinc-400 shrink-0 transition-transform duration-200"
                    [class.rotate-180]="!doCollapsed()" aria-hidden="true">
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </button>

            @if (!doCollapsed()) {
            <div class="border-t border-zinc-100 dark:border-white/5 p-3 flex flex-col gap-y-2.5">
                @for (result of doResults(); track result.id) {
                <ng-container *ngTemplateOutlet="resultCard; context: { result: result }"></ng-container>
                }
            </div>
            }
        </div>
    </ng-template>

    <ng-template #dontAccordion>
        <div class="w-full rounded-2xl border border-zinc-100 dark:border-white/5 bg-white dark:bg-zinc-900 overflow-hidden shadow-sm dark:shadow-none">
            <button type="button" (click)="dontCollapsed.set(!dontCollapsed())"
                class="w-full flex items-center gap-x-3 px-4 py-3 text-left hover:bg-zinc-50 dark:hover:bg-white/3 transition-colors duration-150"
                [attr.aria-expanded]="!dontCollapsed()">
                <div class="shrink-0 flex items-center justify-center size-8 rounded-lg bg-red-50 dark:bg-red-500/10">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="size-4 text-red-500 dark:text-red-400" aria-hidden="true">
                        <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                    </svg>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-primary">Restrictions (Don'ts)</p>
                    <p class="text-xs text-secondary">Items that should be avoided in the content.</p>
                </div>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                    class="size-4 text-zinc-400 shrink-0 transition-transform duration-200"
                    [class.rotate-180]="!dontCollapsed()" aria-hidden="true">
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </button>

            @if (!dontCollapsed()) {
            <div class="border-t border-zinc-100 dark:border-white/5 p-3 flex flex-col gap-y-2.5">
                @for (result of dontResults(); track result.id) {
                <ng-container *ngTemplateOutlet="resultCard; context: { result: result }"></ng-container>
                }
            </div>
            }
        </div>
    </ng-template>

    <!-- ── Shared result card template ──────────────────────────────────── -->
    <ng-template #resultCard let-result="result">
    <div class="flex flex-col w-full rounded-xl border overflow-hidden"
        [class]="result.answer === 'Approved'
            ? 'border-emerald-500/30 dark:border-emerald-500/20'
            : 'border-amber-500/30 dark:border-amber-500/20'">

        <!-- Status banner -->
        @if (result.answer === 'Approved') {
        <div class="flex items-start gap-x-2.5 px-3 py-2.5 bg-emerald-50 dark:bg-emerald-500/10">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"
                class="size-4 text-emerald-500 dark:text-emerald-400 shrink-0 mt-0.5" aria-hidden="true">
                <path d="M21.801 10A10 10 0 1 1 17 3.335" /><path d="m9 11 3 3L22 4" />
            </svg>
            <div class="min-w-0 flex-1">
                <p class="text-xs font-semibold text-emerald-800 dark:text-emerald-300 leading-tight">Statement</p>
                <p class="mt-0.5 text-xs text-emerald-700 dark:text-emerald-200/80 leading-relaxed">{{ result.statement }}</p>
            </div>
        </div>
        } @else {
        <div class="flex items-start gap-x-2.5 px-3 py-2.5 bg-amber-50 dark:bg-amber-500/10">
            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="size-4 text-amber-500 dark:text-amber-400 shrink-0 mt-0.5">
                <path clip-rule="evenodd" fill-rule="evenodd"
                    d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
            </svg>
            <div class="min-w-0 flex-1">
                <div class="flex items-center justify-between gap-2 mb-0.5">
                    <p class="text-xs font-semibold text-amber-800 dark:text-amber-300 leading-tight">Statement</p>
                    <span class="inline-flex items-center rounded-full bg-amber-100 dark:bg-amber-400/10 px-2 py-0.5 text-[10px] font-medium text-amber-700 dark:text-amber-400 ring-1 ring-inset ring-amber-600/20 dark:ring-amber-400/20 shrink-0">
                        Issue Found
                    </span>
                </div>
                <p class="text-xs text-amber-700 dark:text-amber-200/80 leading-relaxed">{{ result.statement }}</p>
            </div>
        </div>
        }

        <!-- Detail rows -->
        @if (result.matchingOcrOrVisual) {
        <div class="px-3 py-2 border-t border-zinc-100 dark:border-white/5">
            <p class="text-[10px] font-semibold uppercase tracking-wide text-zinc-400 dark:text-zinc-500 mb-0.5">OCR & Visual Analysis</p>
            <p class="text-xs text-secondary leading-relaxed">{{ result.matchingOcrOrVisual }}</p>
        </div>
        }

        @if (result.matchingTranscript) {
        <div class="px-3 py-2 border-t border-zinc-100 dark:border-white/5">
            <p class="text-[10px] font-semibold uppercase tracking-wide text-zinc-400 dark:text-zinc-500 mb-0.5">Audio Analysis</p>
            <p class="text-xs text-secondary leading-relaxed">{{ result.matchingTranscript }}</p>
        </div>
        }

        <div class="px-3 py-2 border-t border-zinc-100 dark:border-white/5">
            <p class="text-[10px] font-semibold uppercase tracking-wide text-zinc-400 dark:text-zinc-500 mb-0.5">Explanation</p>
            <p class="text-xs text-secondary leading-relaxed">{{ result.explanation }}</p>
        </div>

        @if (result.suggestedFix) {
        <div class="px-3 py-2 border-t border-primary/15 dark:border-primary/25 bg-primary/10 dark:bg-primary/10">
            <p class="text-[10px] font-semibold uppercase tracking-wide text-accent mb-0.5">Suggested Fix</p>
            <p class="text-xs text-accent/90/80 leading-relaxed">{{ result.suggestedFix }}</p>
        </div>
        }

    </div>
    </ng-template>

</div>
